<template>
  <create-product-layout title="ساخت محصول" :submitFunction="createProduct"/>
</template>
<script>
import {mapActions} from 'vuex';
import CreateProductLayout from "./CreateLayout.vue";


export default {
  name: "CreateProduct",
  components: {CreateProductLayout},
  methods: {
    ...mapActions({
      createProduct: "Product/createProduct"
    })
  }
};
</script>
<style scoped>

</style>